<template>
  <m-form
    :title="title"
    :items="items"
    :cols="cols"
    :canEdit="canEdit"
    :canSubmit="canSubmit"
    :canDelete="canDelete"
    :is-editing.sync="isEditing"
    :showListBtn="false"
    :show-navigation-btns="false"
    list-export-base-url="reports/lists/salePriceTypes"
    :list_filters="{}"
    :exportParams="{id: item.id}"
    @click:row="setItem"
    @clearForm="clearForm"
    @submit="submit"
    @delete="deleteItem"
  >
    <template #default>
      <v-row>
        <v-col cols="12">
          <v-text-field class="rounded-lg" label=" * نام" v-model="item.name" :disabled="!isEditing" />
        </v-col>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import WareApiMixin from "@/mixin/wareApi";
import { MFormMixin } from "@/components/m-form";

export default {
  mixins: [MFormMixin, WareApiMixin],
  data() {
    return {
      item: {},
      baseUrl: "wares/salePriceTypes",
      permissionBasename: "salePriceType",
      cols: [
        {
          text: "نام",
          value: "name",
        },
      ]
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('انواع نرخ های فروش')
    },
    items() {
      return this.salePriceTypes;
    }
  },
  methods: {
    getData() {
      this.getSalePriceTypes(true);
    }
  }
};
</script>